import type { ReactNode } from 'react'

export interface NativeRouteGuardProps {
  available: boolean
  fallback: ReactNode
  children: ReactNode
}

/** Exibe `fallback` quando a feature não está disponível no shell nativo.
 *  Não implementa navegação «Voltar» nem hierarquia de rotas — ver docs/internal/NAVIGATION_BACK.md. */
export const NativeRouteGuard = ({ available, fallback, children }: NativeRouteGuardProps) => {
  if (!available) {
    return <>{fallback}</>
  }
  return <>{children}</>
}
